module.exports = __webpack_public_path__ + "img/product-forbidden-4.59a39fe4.png";